import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tenant-not-found',
  templateUrl: './tenant-not-found.component.html',
  styleUrls: ['./tenant-not-found.component.css']
})
export class TenantNotFoundComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
